import React from "react";
import Favourites from "../Favourites";
function Favourite() {
  return (
    <div>
      <Favourites />
    </div>
  );
}

export default Favourite;
